module.exports = __webpack_public_path__ + "img/te-mision2.6465ea9b.jpg";